export const AUTH_SIGN_IN = 'AUTH_SIGN_IN';
export const AUTH_SIGN_UP = 'AUTH_SIGN_UP';
export const AUTH_LOG_OUT = 'AUTH_LOG_OUT';
export const AUTH_SET_ERROR = 'AUTH_SET_ERROR';
export const AUTH_SET_PENDING = 'AUTH_SET_PENDING';
export const AUTH_SET_USERDATA = 'AUTH_SET_USERDATA';
export const AUTH_SET_PRICETYPE = 'AUTH_SET_PRICETYPE';
export const AUTH_SET_USERTYPE = 'AUTH_SET_USERTYPE';
export const AUTH_SET_USER_OPTION = 'AUTH_SET_USER_OPTION';
